import { Button, Dialog, Loading } from '@startlibs/components';
import { Combobox, Errors, Field, WithForm } from '@startlibs/form';
import {formFetch, getColor} from '@startlibs/utils'
import React, {Suspense} from 'react'
import _ from 'lodash/fp'
import styled from 'styled-components'
import {StudyCard} from './StudyCard'
import {useSuspense} from '../../hooks/useSuspense'
import {useNotificationRef} from '../../components/Notifications'

const OPTIONS = [
  "Normal",
  "STAT",
  "Time sensitve"
]

const ComboboxContainer = styled.div `
  position: relative;
  ${Loading} {
    position: absolute;
    top: 8px;
    right: 0.75rem;
    background: white;
  }
`

const ComboboxAssignment = styled(Combobox)`
  .not-assigned {
    font-style: italic;
    color: ${getColor('gray180')};
  }
  ul.context-menu.combobox-menu li:first-child {
      border-bottom: 1px solid ${getColor('gray240')};
      .not-assigned {
        color: ${getColor('gray180')};
      }
      &:hover, &.hover-item {
        .not-assigned {
          color: white;
        }
      }
    }
  }
`

export const EditAssignmentDialog = ({study, setStudy, closeDialog}) => {
  const [,setNotification] = useNotificationRef()

  return <WithForm
    action={formFetch("/new_reassign_update.php")}
    onSuccess={({study_assigned_to}) => {
      setStudy(_.set('assignment.assignee', study_assigned_to));
      closeDialog()
      setNotification("Assigned radiologist updated  successfully.")
    }}
    values={{study_assigned_to: study.assignment.assignee, id: study.study.id}}
  >{form =>
    <Dialog
      title="Radiologist assignment"
      closeDialog={closeDialog}
      footer={<>
        <Button onClick={closeDialog}>Cancel</Button>
        <Button type="submit" highlight onClick={form.willSubmitForm} isLoading={form.isLoading}>Update
          assignment</Button>
      </>}
    >
      <StudyCard study={study}/>
      <Field label="Select a radiologist to be assigned:"
             descText={<>Currently assigned to: <b css="color:rgb(120,120,120)">{study.assignment.assignee}</b></>}>
        <Suspense fallback={<ComboboxContainer><ComboboxAssignment disabled path="study_assigned_to"
                                                         options={[study.assignment.assignee]}/><Loading
          size={21}/></ComboboxContainer>}>
          <RadiologistOptions/>
        </Suspense>
      </Field>
      <Errors/>
    </Dialog>
  }</WithForm>
}


const getLabel = (s) => s.length === 0 ? <span className="not-assigned">Not assigned</span> : s
const RadiologistOptions = () => {

  const OPTIONS = ["",...useSuspense("/StudyRadiologistList.php")]

  return <ComboboxAssignment path="study_assigned_to" options={OPTIONS} getLabel={getLabel}/>
}
